import { useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHeartbeat } from '../store/actions/AssessmentActions';
import { HEARTBEAT_TYPE_OVERALL } from '../const';

const interval = 10000;
const useHeartbeat = (assessment_id, type = HEARTBEAT_TYPE_OVERALL, currentSectionId = null) => {
  const dispatch = useDispatch();
  const intervalRef = useRef(null);
  const assessmentSubmissionStatus = useSelector(
    state => state.assessment.assessmentSubmissionStatus,
  );

  const clearHeartbeat = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  useEffect(() => {
    if (!intervalRef.current && assessment_id) {
      intervalRef.current = setInterval(() => {
        dispatch(fetchHeartbeat(assessment_id, type, currentSectionId));
      }, interval);
    }

    return () => {
      clearHeartbeat();
    };
  }, [dispatch, assessment_id, type, currentSectionId, interval, clearHeartbeat]);

  // Clear heartbeat when assessment is submitted
  useEffect(() => {
    if (assessmentSubmissionStatus === 'Submitted') {
      clearHeartbeat();
    }
  }, [assessmentSubmissionStatus, clearHeartbeat]);

  return clearHeartbeat;
};

export default useHeartbeat;
